import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Spinner,
} from 'reactstrap';
import DropzoneField from './uploadFiles';

import axios from 'axios';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../../../../app/config/store';
import { useNavigate } from 'react-router';
import Stepperform from '../../shared/layout/stepperform/stepperform';
import FooterComponent from '../../shared/layout/footer/footer';
import { getSubscription } from '../../entities/case-forms/case-lawyer.reducer';
import _ from 'lodash';
const CaseEvidence = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [preview, setPreview] = useState<any>([]);
  const { id } = useAppSelector(state => state.authentication?.account);
  const [showModal, setShowModal] = useState<any>(false);
  const [formData, setFormData] = useState<any>();
  const [editingIndex, setEditingIndex] = useState(null);
  const [errors, setErrors] = useState<any>({});
  const [files, setFiles] = useState<any>('');
  const [submitted, setSubmitted] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);
  const [editId, setEditId] = useState<any>('');
  const [isDeleted, setisDeleted] = useState(false);
  const [isAddMore, setIsAddMore] = useState<boolean>(false);
  const [evidenceDelete, setevidenceDelete] = useState(false);
  const chatId_step3 = localStorage.getItem('aichatId_step3') || '';
  const navigate = useNavigate();

  const apiUrl = 'api/workflows/steps';

  const get_forms = async chatId => {
    const id = chatId ? chatId : chatId_step3;
    try {
      setLoader(true);
      const secondUrl = `${apiUrl}/${id}`;
      const resp = await axios.get(secondUrl);
      const fieldData = resp.data?.data?.parentWorkflowStepMetaDataFields;
      setFormData(fieldData);
      setLoader(false);
      id && (await getUploadedDocument(id));
    } catch (error) {
      console.error('error', error);
      setLoader(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoader(true);
        let chatId: any;
        if (!chatId_step3) {
          const requestUrl = `api/workflows/6491/start?extRefKey=${id}`;
          // const requestUrl = `api/workflows/${process.env.IS_DEV ? '4776' : '6491'}/start?extRefKey=${id}`;
          const response = await axios.get(requestUrl);
          chatId = response?.data?.data;

          if (chatId) {
            localStorage.setItem('aichatId_step3', chatId);
          }
        }

        if (chatId_step3 || localStorage.getItem('aichatId_step3')) {
          await get_forms(chatId);
        }
      } catch (error) {
        console.error('Error during chatId setup or form fetch:', error);
      } finally {
        setLoader(false);
      }
    };

    init();
  }, [id, chatId_step3]);

  //   useEffect(()=>{
  //   (async()=>{
  //   const plan: any = id && (await getSubscription(id));
  //   plan==null && navigate('/plan');
  //   })()

  // },[])

  const getUploadedDocument: any = async chatId => {
    const requestUrl = `api/retrieve/upload-file?aiAssistantId=6491&fileUseType=USER_SOURCE_DOCUMENT&extRefKey=${id}&aiChatId=${chatId || chatId_step3}`;
    try {
      const resp = await axios.get(requestUrl, {
        headers: {
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });
      setPreview(resp.data?.data);
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };

  const evidenceType = ['Document', 'Image', 'Video', 'Audio'];

  const deleteFiles = async id => {
    if (!id) return;
    const requestUrl = `api/upload-file/v2/${Number(id)}`;
    try {
      const resp = await axios.delete(requestUrl, {
        headers: {
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });
      if (resp?.status == 200) {
        toast.success('Evidence deleted successfully!', { position: 'top-right' });
        setPreview(pre => pre.filter(itm => itm?.id !== id));
        setEditId('');
        setShowModal(false);
      }
    } catch (error) {
      toast.error('Something went wrong', { position: 'top-right' });
      console.error('Error deleting file:', error);
    }
    setevidenceDelete(false);
  };

  const removeEvidence = () => {
    setevidenceDelete(true);
    deleteFiles(editId);
    setisDeleted(true);
    return;
  };

  const validateField = () => {
    let errorsObj = {};
    formData?.forEach(field => {
      if (field.name !== 'Evidence' && field.name !== 'Media upload') {
        if (!field.value || field.value == '' || (Array.isArray(field.name) && field.name.length === 0)) {
          errorsObj[field.name] = `${field.name} is required`;
        }
        return '';
      }
    });
    setErrors(errorsObj);
    return Object.keys(errorsObj).length === 0;
  };

  const handleChange = (e, index) => {
    const { name, value, type, files } = e.target;
    setFormData(prevData => prevData.map((field, i) => (i === index ? { ...field, value: type === 'file' ? files : value } : field)));
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const handleFileChange = (file, fieldName, index) => {
    const mediaFiles = Array.from(file)
      .map((file: any) => file?.name)
      .join(', ');

    setFormData(prevData => prevData.map((field, i) => (i === index ? { ...field, value: mediaFiles } : field)));
    setErrors(prevErrors => ({
      ...prevErrors,
      ['Media upload']: '',
    }));
    setisDeleted(false);
  };

  const editEvidenceData = async () => {
    const requestUrl = 'api/file-metadata/update';
    const payload = {
      metadata: formData,
      fileUploadId: editId,
    };

    try {
      const response = await axios.post(requestUrl, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });
      const data = response.data;
      if (response.status === 200) {
        setEditingIndex(null);
        getUploadedDocument();
        toast.success('Updated successfully!', { position: 'top-right' });
        setSubmitted(false);
        setisDeleted(true);
        setFormData(prevData =>
          prevData.map(field => ({
            ...field,
            value: field.formInputType === 'FILE' ? [] : '',
          })),
        );
        return true;
      } else {
        setisDeleted(true);
        toast.error('Upload failed!', { position: 'top-right' });
        setSubmitted(false);
        return false;
      }
    } catch (error) {
      setisDeleted(true);
      toast.error('Upload error. Please try again!', { position: 'top-right' });
      setSubmitted(false);
      return false;
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateField()) return;
    if (editingIndex == null) {
      uploadFiles();
    } else {
      editEvidenceData();
    }
  };

  const uploadFiles = async () => {
    let bodyFormData = new FormData();
    const transformedData = formData.map(item => {
      if (item.formInputType === 'FILE') {
        if (item.value && item.value.length > 0) {
          return { [item.name]: item.value };
        } else {
          return { [item.name]: '' };
        }
      } else {
        return { [item.name]: item.value || '' };
      }
    });
    setIsAddMore(true);
    // const transformedData = formData.map(item => ({ [item.name]: item.value ? item.value : '' }));

    bodyFormData.append('metadataJson', JSON.stringify(transformedData));
    bodyFormData.append('title', 'test');
    bodyFormData.append('description', 'description122');
    const requestUrl = `api/upload-file?extRefKey=${id}`;

    files &&
      files[0].forEach(file => {
        bodyFormData.append('files', file);
      });

    bodyFormData.append('sourceLocation', 'test3');
    bodyFormData.append('fileUseType', 'USER_SOURCE_DOCUMENT');
    bodyFormData.append('aiAssistantId', '6491');
    bodyFormData.append('aiChatId', chatId_step3);

    try {
      const response = await axios.post(requestUrl, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // 'Workflow-Authorization': 'Dyhac$25!',
        },
      });
      const data = response.data;
      if (response.status === 200) {
        if (data?.data[0]?.status == 'success') {
          setisDeleted(true);
          setPreview(pre => [...pre, data?.data[0]?.data]);
          toast.success('Uploaded successfully!', { position: 'top-right' });
          setSubmitted(false);
          setIsAddMore(false);
          setFiles('');
          setFormData(prevData =>
            prevData.map(field => ({
              ...field,
              value: field.formInputType === 'FILE' ? [] : '',
            })),
          );
          return true;
        } else {
          setisDeleted(true);
          toast.error('Upload failed!', { position: 'top-right' });
          setSubmitted(false);
          setIsAddMore(false);
          return false;
        }
      } else {
        setisDeleted(true);
        setIsAddMore(false);
        toast.error('Upload failed!', { position: 'top-right' });
        setSubmitted(false);
        return false;
      }
    } catch (error) {
      setIsAddMore(false);
      toast.error('Upload error. Please try again!', { position: 'top-right' });
      setSubmitted(false);
      return false;
    }
  };

  const saveStepToLocalStorage = () => {
    const submittedStr = localStorage.getItem('submittedstep');
    const submitted = submittedStr ? JSON.parse(submittedStr) : {};

    const userSteps = submitted[id] || [];
    const currentStep = 3;
    if (!userSteps.includes(currentStep)) {
      userSteps.push(currentStep);
      submitted[id] = userSteps;
      localStorage.setItem('submittedstep', JSON.stringify(submitted));
      localStorage.setItem('step', JSON.stringify(4));
    }
    navigate('/report');
  };

  const handleNext = async () => {
    if (preview?.length === 0) {
      if (!validateField()) return;

      if (!_.isEmpty(errors)) {
        setSubmitted(true);
        const isUploaded = await uploadFiles();
        if (isUploaded) {
          saveStepToLocalStorage();
        }
      }
    } else {
      if (_.isEmpty(errors)) {
        saveStepToLocalStorage();
      } else {
        const isUploaded = await uploadFiles();
        if (isUploaded) {
          saveStepToLocalStorage();
        }
      }
    }

    setSubmitted(true);
  };

  // const handleNext = async () => {
  //   if (preview?.length > 0) {
  //     setSubmitted(true);
  //     submittedArray.push(3);
  //     localStorage.setItem('submitted', JSON.stringify(submittedArray));
  //     localStorage.setItem('step', JSON.stringify(4));
  //     navigate('/report');
  //   } else {
  //     if (!validateField()) return;
  //     setSubmitted(true);
  //     const isUploaded = await uploadFiles();
  //     if (isUploaded) {
  //       submittedArray.push(3);
  //       localStorage.setItem('submitted', JSON.stringify(submittedArray));
  //       localStorage.setItem('step', JSON.stringify(4));
  //       navigate('/report');
  //     }
  //   }

  //   return;
  // };

  const handleEdit = (evidenceData, index) => {
    setFormData(prevData =>
      prevData.map(field => {
        const matchingField = evidenceData.fileMetadata?.find(meta => meta.name === field.name);
        return matchingField ? { ...field, value: matchingField.value } : field;
      }),
    );
    setEditingIndex(index);
    setisDeleted(false);
    setEditId(evidenceData?.id);
  };

  const handleOpenModal = evidence => {
    setEditId(evidence?.id);
    setShowModal(true);
  };

  const handleCancel = () => {
    setFormData(prevData =>
      prevData.map(field => ({
        ...field,
        value: field.formInputType === 'FILE' ? [] : '',
      })),
    );
    setEditingIndex(null);
    setisDeleted(true);
  };
  const handleSelect = selectedOption => {
    setFormData(prevData =>
      prevData.map(field => ({
        ...field,
        value: field.formInputType === 'SELECT' ? selectedOption : field.value,
      })),
    );
    setErrors(prevErrors => ({
      ...prevErrors,
      ['Evidence']: '',
    }));
  };

  const CloseModal = () => {
    setShowModal(false);
    setEditId('');
  };

  return (
    <>
      <Modal isOpen={showModal} centered className="user-settings-modal">
        <ModalBody>
          <div>
            <p> Are you sure you want to delete this evidence? </p>
            <ModalFooter>
              {!evidenceDelete ? (
                <Button type="submit" className="save-btn" onClick={() => removeEvidence()}>
                  Delete
                </Button>
              ) : (
                <div className="save-btn" style={{ padding: '10px 20px', minHeight: '45px', minWidth: '77px' }}>
                  <Spinner size={'sm'}>Loading...</Spinner>
                </div>
              )}
              <Button type="submit" style={{ padding: '10px 20px 10px 20px' }} onClick={() => CloseModal()}>
                Cancel
              </Button>
            </ModalFooter>
          </div>
        </ModalBody>
      </Modal>
      <div className="main-content flex-grow-1 d-flex flex-column gap-5 justify-content-between px-4 pb-4">
        <div className="custom-container flex-grow-1">
          <h1 className="page-title">Case Details Form</h1>
          <Stepperform />
          <Card className="card-wrapper">
            <h3 className="form-title">Evidence Documenter Screen</h3>
            <p> Complete the questions below</p>
            {!loader ? (
              <Form className="mt-3">
                <Row>
                  {formData?.map((field, index) => (
                    <>
                      <Col md="6" key={index} className="mb-3">
                        <FormGroup key={index}>
                          <Label>{field.name}</Label>
                          {field.formInputType === 'TEXTAREA' ? (
                            <>
                              <Input
                                type="textarea"
                                name={field.name}
                                id={field.name}
                                style={{ resize: 'none' }}
                                placeholder="Describe how the file is relevant evidence."
                                value={field.value}
                                // value={formValues[field.name]}
                                onChange={e => handleChange(e, index)}
                                invalid={!!errors[field.name]}
                              />
                              <FormFeedback>{errors[field.name]}</FormFeedback>
                            </>
                          ) : field.formInputType === 'SELECT' ? (
                            <>
                              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle caret className="dropdown-toggle-custom">
                                  {field.value ? field.value : 'Select'}
                                </DropdownToggle>
                                <DropdownMenu className="custom-dropdown">
                                  {evidenceType.length > 0 ? (
                                    evidenceType.map((option, index) => (
                                      <DropdownItem
                                        key={index}
                                        name={field?.name}
                                        className={`custom-option ${field.value === option ? 'selected-option' : ''}`}
                                        onChange={e => handleChange(e, index)}
                                        onClick={() => handleSelect(option)}
                                      >
                                        {option}
                                      </DropdownItem>
                                    ))
                                  ) : (
                                    <DropdownItem disabled>No options available</DropdownItem>
                                  )}
                                </DropdownMenu>
                              </Dropdown>
                              <FormFeedback>{errors[field.name]}</FormFeedback>
                            </>
                          ) : field.formInputType === 'DATE' ? (
                            <>
                              <Input
                                type="date"
                                name={field.name}
                                id={field.name}
                                value={field.value}
                                className={errors[field.name] ? 'is-date' : ''}
                                invalid={!!errors[field.name]}
                                onChange={e => handleChange(e, index)}
                                max={new Date().toISOString().split('T')[0]}
                                style={{ cursor: 'pointer' }}
                              />
                              <FormFeedback>{errors[field.name]}</FormFeedback>
                            </>
                          ) : field.formInputType === 'FILE' ? (
                            <>
                              <DropzoneField
                                // onFilesChange={handleChange}
                                sectionIndex={index}
                                editId={editId}
                                fieldKey={field.name}
                                value={field?.value}
                                id={field?.id}
                                setFiles={setFiles}
                                onFilesChange={files => handleFileChange(files, field.name, index)}
                                isDeleted={isDeleted}
                              />
                              <FormFeedback>{errors[field.name]}</FormFeedback>
                            </>
                          ) : (
                            <Input
                              type={field.type?.toLowerCase()}
                              name={field.name}
                              id={field.name}
                              value={field?.value}
                              // value={formValues[field.name]}
                              onChange={e => handleChange(e, index)}
                              invalid={!!errors[field.name]}
                            />
                          )}
                        </FormGroup>
                      </Col>
                    </>
                  ))}
                  <Col sm="12" className="mb-3">
                    {preview?.map((evidence: any, index) => {
                      const exhibitLabel = String.fromCharCode(65 + index);
                      return (
                        <Card key={evidence?.id} className="mb-3 card-evidence-layout">
                          <CardBody>
                            <div className="d-flex gap-3 justify-content-between align-items-center mb-3">
                              <CardTitle className="card_Title mb-0">Exhibit {exhibitLabel}</CardTitle>
                              <div className="d-flex justify-content-end gap-2">
                                {editingIndex !== index ? (
                                  <>
                                    {/* <Button color="secondary" size="sm" onClick={() => handleEdit(evidence, index)}>
                                    Edit
                                  </Button> */}
                                    <Button color="danger" size="sm" onClick={() => handleOpenModal(evidence)}>
                                      Delete
                                    </Button>{' '}
                                  </>
                                ) : (
                                  <Button color="danger" size="sm" onClick={() => handleCancel()}>
                                    Cancel
                                  </Button>
                                )}
                              </div>
                            </div>

                            <Row>
                              {evidence?.fileMetadata?.map(item => (
                                <Col md="6" lg="3" key={item?.id}>
                                  <CardText>
                                    <strong>{item?.name} </strong>{' '}
                                    {item?.value ? item.value : item?.name === 'Evidence' ? 'Not Selected' : 'No file uploaded'}
                                  </CardText>
                                </Col>
                              ))}
                            </Row>
                          </CardBody>
                        </Card>
                      );
                    })}
                  </Col>

                  <div className="d-flex col-12 gap-3">
                    <Button
                      className="theme-button-dark"
                      disabled={isAddMore}
                      onClick={e => {
                        handleSubmit(e);
                      }}
                    >
                      {editingIndex !== null ? 'Update' : 'Add More Evidence'}
                    </Button>
                    <Button className="theme-button" onClick={handleNext}>
                      {submitted ? <Spinner size="sm">Loading...</Spinner> : 'Next'}
                    </Button>
                  </div>
                </Row>
              </Form>
            ) : (
              <div style={{ justifyItems: 'center', alignItems: 'center', left: 0, top: 0, position: 'relative', display: 'grid' }}>
                <Spinner>Loading...</Spinner>
              </div>
            )}
          </Card>
        </div>
        <FooterComponent />
      </div>
    </>
  );
};

export default CaseEvidence;
